import { useEffect } from "react";

export default function Seo({ title, description, canonical }) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
    let link = document.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute("href", canonical);
    window.scrollTo(0, 0);
  }, [title, description, canonical]);
  return null;
}
